<template>

    <div class="industry__screen noselect">

        <markdown :color="'#3a4f41'" :text="$t('stories_screen_2_text')" class="industry__title"></markdown>

    </div>

</template>

<script>

import Markdown from '@/components/Markdown'

export default {

    name: 'industry',

    components: {Markdown},

    props: {},

    methods: {}

}

</script>

<style lang="scss" scoped>

.industry {
    &__screen {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        background-color: $forest;
        color: $sand;
        background-image: url("/img/icons/illustrationStoriesFactory@3x.png");
        background-repeat: no-repeat;
        background-position-x: left;
        background-position-y: bottom;
        background-size: contain;
        padding: 24px;
    }

    &__title {
        font-size: 22px;
        font-weight: bold;
        margin-top: 98px;
    }
}

</style>

